import { compose } from "redux";
import { Launch } from "@material-ui/icons";
import React, { PureComponent } from "react";
import { Link as ReactRouterDomLink } from "react-router-dom";
import { withStyles, Link as MaterialUILink } from "@material-ui/core";

class Link extends PureComponent {
  render() {
    const { classes, children, external, target, ...rest } = this.props;

    return (
      <MaterialUILink
        target={target}
        className={classes.root}
        rel={target === "_blank" ? "noopener" : undefined}
        component={external ? undefined : ReactRouterDomLink}
        {...rest}
      >
        {children}
        <Launch fontSize="small" className={classes.icon} />
      </MaterialUILink>
    );
  }
}

MaterialUILink.defaultProps = {
  variant: "body1",
};

const styles = theme => ({
  root: {
    display: "flex",
    cursor: "pointer",
    alignItems: "center",
  },
  icon: {
    fontSize: "inherit",
    marginLeft: theme.spacing(0.25),
  },
});

export default compose(withStyles(styles))(Link);
